import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup";
import getColor from "@insite/mobius/utilities/getColor";
import { signInExistingAccountStyles } from "@waytek/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
    globalDarkerGray: getColor("common.global.darkerGray"),
};

signInExistingAccountStyles.signInExistingAccountGrid = {
    ...signInExistingAccountStyles.signInExistingAccountGrid,
    css: css`
        ${mediaQueriesBP.minLG} {
            padding-right: 30px;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountTitleGrid = {
    ...signInExistingAccountStyles.signInExistingAccountTitleGrid,
    width: 12,
    css: css`
        padding-bottom: 6px;

        ${mediaQueriesBP.minLG} {
            padding-bottom: 10px;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountFormGrid = {
    ...signInExistingAccountStyles.signInExistingAccountFormGrid,
    width: 12,
    css: css`
        padding-top: 6px;

        ${mediaQueriesBP.minLG} {
            padding-top: 10px;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    ...signInExistingAccountStyles.signInExistingAccountTitle,
    fontFamily,
    css: css`
        flex: 1;
        border-bottom: solid 3px ${localColors.globalIndustrialTaupe};
        padding-bottom: 5px;
    `,
};

signInExistingAccountStyles.form = {
    ...signInExistingAccountStyles.form,
    css: css`
        width: 100%;

        ${mediaQueriesBP.minLG} {
            max-width: 335px;
        }
    `,
};

signInExistingAccountStyles.userNameGridItem = {
    ...signInExistingAccountStyles.userNameGridItem,
    css: css`
        ${mediaQueriesBP.maxMD} {
            padding-bottom: 10px;
        }
    `,
};

signInExistingAccountStyles.userNameTextField = {
    ...signInExistingAccountStyles.userNameTextField,
    labelProps: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            line-height: 1.71;
        `,
    },
};

signInExistingAccountStyles.passwordGridItem = {
    ...signInExistingAccountStyles.passwordGridItem,
    css: css`
        padding-bottom: 5px;

        ${mediaQueriesBP.maxMD} {
            padding-top: 10px;
        }
    `,
};

signInExistingAccountStyles.passwordTextField = {
    ...signInExistingAccountStyles.passwordTextField,
    labelProps: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            line-height: 1.71;
        `,
    },
};

signInExistingAccountStyles.rememberMeGridItem = {
    ...signInExistingAccountStyles.rememberMeGridItem,
    css: css`
        ${CheckboxGroupStyle} {
            & > legend:empty,
            & > span:empty {
                display: none;
            }
        }
    `,
};

signInExistingAccountStyles.rememberMeCheckbox = {
    ...signInExistingAccountStyles.rememberMeCheckbox,
    css: css`
        label {
            color: ${localColors.globalDarkerGray};
        }
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    ...signInExistingAccountStyles.signInButtonGridItem,
    css: css`
        justify-content: flex-start;

        ${mediaQueriesBP.minLG} {
            padding-top: 25px;
        }
    `,
};

signInExistingAccountStyles.signInButton = {
    ...signInExistingAccountStyles.signInButton,
    css: css`
        ${mediaQueriesBP.maxMD} {
            width: 100%;
        }
    `,
};
